import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  root: {
    margin: 20,
    padding: 10,
  },
  title: {
    margin: 10,
    marginLeft: -10,
  },
  button: {
    margin: "0 5px",
    background: theme.palette.primary.main,
    color: 'white',
    '&:hover': {
      background: theme.palette.green,
    }
  },
  buttonsWrapper: {
    margin: "20px 0"
  }
}));

export default useStyles;
